export default {
  ADMIN: "admin",
  EXPERT: "expert",
  USER: "user",
}
